// extracted by mini-css-extract-plugin
module.exports = {"deleteImage":"form_deleteImage_2RieR"};